export const acoesRealizadasMap = {
    SOLICITACAO_CRIADA: "Solicitação Criada",
    SOLICITACAO_AGENDADA: "Solicitação Agendada",
    SOLICITACAO_ALTERADA: "Solicitação Atualizada",
    SOLICITACAO_EXCLUIDA: "Solicitação Excluída",
    SOLICITACAO_ENVIADA: "Solicitação Enviada",
    RESPOSTA_ENVIADA: "Resposta da Solicitação Enviada",
    RELATORIO_ENVIADO: "Relatório Enviado",
    PLANO_ACAO_ENVIADO: "Plano de Ação Enviado",
    SOLICITACAO_CONCLUIDA: "Solicitação Encerrada"
};